var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Desfecho do atendimento","type":"section"}},[_c('Form',{attrs:{"data":_vm.data,"is-medico":_vm.isMedico,"is-saved":_vm.isSaved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }